/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Script_Name_LabelInputs */

const en_image_export_script_name_label = /** @type {(inputs: Image_Export_Script_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Script Name`)
};

const fr_image_export_script_name_label = /** @type {(inputs: Image_Export_Script_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom du script`)
};

const de_image_export_script_name_label = /** @type {(inputs: Image_Export_Script_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skriptname`)
};

const it_image_export_script_name_label = /** @type {(inputs: Image_Export_Script_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome dello script`)
};

const ru_image_export_script_name_label = /** @type {(inputs: Image_Export_Script_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Название скрипта`)
};

const es_image_export_script_name_label = /** @type {(inputs: Image_Export_Script_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre del script`)
};

const zh_cn2_image_export_script_name_label = /** @type {(inputs: Image_Export_Script_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`脚本名称`)
};

const ja_image_export_script_name_label = /** @type {(inputs: Image_Export_Script_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スクリプト名`)
};

const hi_image_export_script_name_label = /** @type {(inputs: Image_Export_Script_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्क्रिप्ट का नाम`)
};

const pt_pt2_image_export_script_name_label = /** @type {(inputs: Image_Export_Script_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome do roteiro`)
};

/**
* | output |
* | --- |
* | "Script Name" |
*
* @param {Image_Export_Script_Name_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_script_name_label = /** @type {((inputs?: Image_Export_Script_Name_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Script_Name_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_script_name_label(inputs)
	if (locale === "de") return de_image_export_script_name_label(inputs)
	if (locale === "it") return it_image_export_script_name_label(inputs)
	if (locale === "ru") return ru_image_export_script_name_label(inputs)
	if (locale === "es") return es_image_export_script_name_label(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_script_name_label(inputs)
	if (locale === "ja") return ja_image_export_script_name_label(inputs)
	if (locale === "hi") return hi_image_export_script_name_label(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_script_name_label(inputs)
	return en_image_export_script_name_label(inputs)
});